import { t } from 'i18next';

import { ChargesStatus } from 'types/pwcOrder';

const STATUS_LABELS: Record<ChargesStatus, [string, string]> = {
  [ChargesStatus.SUBMITTED]: ['page.pwcOrders.components.status.submitted', 'Submitted'],
  [ChargesStatus.CONFIRMED]: ['page.pwcOrders.components.status.confirmed', 'Confirmed'],
  [ChargesStatus.COMPLETED]: ['page.pwcOrders.components.status.completed', 'Completed'],
  [ChargesStatus.CANCELED]: ['page.pwcOrders.components.status.canceled', 'Canceled'],
  [ChargesStatus.DECLINED]: ['page.pwcOrders.components.status.declined', 'Declined'],
  [ChargesStatus.FAILED]: ['page.pwcOrders.components.status.failed', 'Failed'],
};

export const LABELS = {
  STATUS: STATUS_LABELS,
};

export const badgePropsMap: Record<ChargesStatus, { type: ChargesStatus; label: string }> = {
  [ChargesStatus.SUBMITTED]: {
    type: ChargesStatus.SUBMITTED,
    label: t(LABELS.STATUS.SUBMITTED),
  },
  [ChargesStatus.CONFIRMED]: {
    type: ChargesStatus.CONFIRMED,
    label: t(LABELS.STATUS.CONFIRMED),
  },
  [ChargesStatus.COMPLETED]: {
    type: ChargesStatus.COMPLETED,
    label: t(LABELS.STATUS.COMPLETED),
  },
  [ChargesStatus.CANCELED]: {
    type: ChargesStatus.CANCELED,
    label: t(LABELS.STATUS.CANCELED),
  },
  [ChargesStatus.DECLINED]: {
    type: ChargesStatus.DECLINED,
    label: t(LABELS.STATUS.DECLINED),
  },
  [ChargesStatus.FAILED]: {
    type: ChargesStatus.FAILED,
    label: t(LABELS.STATUS.FAILED),
  },
};
